import { call, put, select, take } from 'redux-saga/effects';

import api from 'api';
import { IPersonalPlanResponse } from 'api/components/PersonalPlan/types';

import {
    generatePlanRequest,
    getCurrentPlanSuccess,
    resetSelectedWorkoutDay,
    setCurrentPlanCompletion,
} from 'store/personalPlan/actions';
import { updateUserRequest } from 'store/user/actions';
import { UPDATE_USER_ERROR, UPDATE_USER_SUCCESS } from 'store/user/actionTypes';

import { PlanType } from 'constants/personalPlan';
import { FitnessLevel } from 'constants/user';

import { addCompletenessToWorkouts } from 'helpers/personalPlan';

import { selectPlanLevel, selectPlanType } from '../selectors';

import { getWorkout } from './getWorkout';

export function* generatePlan({ payload }: ReturnType<typeof generatePlanRequest>) {
    try {
        yield put(setCurrentPlanCompletion(false));
        yield put(resetSelectedWorkoutDay());

        const planType: PlanType | null = yield select(selectPlanType);
        const planLevel: FitnessLevel = yield select(selectPlanLevel);

        if (payload.level && payload.level !== planLevel) {
            yield put(updateUserRequest({ payload: { fitness_level: payload.level } }));

            yield take([UPDATE_USER_SUCCESS, UPDATE_USER_ERROR]);
        }

        const { id, current_day, days, yoga_type, plan_type, instructor }: IPersonalPlanResponse = yield call(
            api.personalPlan.generatePersonalPlan,
            { plan_type: planType ?? PlanType.Standard }
        );

        const workouts = addCompletenessToWorkouts({ days, currentDay: current_day });

        yield put(
            getCurrentPlanSuccess({
                id,
                current_day,
                days: workouts,
                yoga_type,
                plan_type,
                instructor,
            })
        );

        yield call(getWorkout);
    } catch (error: any) {
        console.error('Generate personal plan error: ', error.message);
    }
}
